/* RESPONSIBLE TEAM: team-inbox */
import Model, { hasMany } from '@ember-data/model';

export default class DomainObjectInstance extends Model {
  @hasMany('conversation-attributes/conversation-attribute-value', { async: false }) attributes;
}
